/**
 * For getting the essensys base url on the client side, server side
 * can get this from the server-config
 */
export function getEssensysBaseUrl(): string {
  return 'https://operate.essensys.tech';
}
